import type { LibraryClass } from '@engage/classes';
import type {
  ScheduledClassDetailsFragment,
  ScheduledUsersFragment,
} from '@members/graphql-swr/schemas/scheduled-classes/queries/shared-fragments.generated';
import type { ViewProps } from './ConnectedOnDemandModal';

export enum OnDemandModalViewType {
  ClassDetails = 'classDetails',
  ScheduleClass = 'scheduleClass',
  ScheduleClassConfirmation = 'scheduleClassConfirmation',
  RescheduleClass = 'rescheduleClass',
  AdditionalInstructors = 'additionalInstructors',
  MembersYouFollow = 'membersYouFollow',
  ViewDetails = 'viewDetails',
  ViewMovementGroupVideo = 'viewMovementGroupVideo',
}

export type ModalNavProps = {
  goBack: () => void;
  navigateTo: (page: OnDemandModalViewType) => void;
};

export type ViewComponentProps = ViewProps &
  ModalNavProps & {
    shouldShowButtons: boolean;
    isEntered: boolean;
    lastView: OnDemandModalViewType;
  };

export type SchedulingModalProps = ViewComponentProps & {
  currScheduledClass: (ScheduledClassDetailsFragment & ScheduledUsersFragment) | null;
  setCurrScheduledClass: (
    _: ScheduledClassDetailsFragment & ScheduledUsersFragment,
  ) => void;
};

export type ClassInLibrary = LibraryClass & { isInLibrary: true };
